var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1401 0.821289C7.58246 0.821289 -1.64987 14.5595 3.46357 27.1156L5.65202 32.4824C5.74759 32.7164 5.76497 32.9751 5.70157 33.2198C5.63816 33.4646 5.49737 33.6823 5.30018 33.8405L0.672287 37.5536C0.48282 37.7056 0.345225 37.9127 0.278506 38.1462C0.211787 38.3798 0.219236 38.6283 0.299825 38.8575C0.380413 39.0866 0.530164 39.2851 0.728395 39.4255C0.926627 39.5659 1.16356 39.6412 1.40646 39.6412H19.7492C22.4391 39.6415 25.1027 39.1119 27.588 38.0828C30.0732 37.0536 32.3314 35.545 34.2336 33.643C36.1357 31.7411 37.6446 29.483 38.6741 26.9979C39.7035 24.5128 40.2334 21.8492 40.2334 19.1593C40.2334 9.03094 32.0238 0.821289 21.8954 0.821289H21.1425H21.1401Z",
    fill: "#00AB55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.395ba74025c5f40e8a17d613c4ce01d2.svg";
export { ForwardRef as ReactComponent };